import { useMemo } from "react";

import useIsMobile from "web/hooks/useIsMobile";
import useIsNativeApp from "web/hooks/useIsNativeApp";
import useIsPrint from "web/hooks/useIsPrint";
import useModal from "web/hooks/useModal";

import useAppMode from "../useAppMode";

const useProviderValue = () => {
  const {
    component,
    modalRef,
    menuIndex,
    dispatch,
    classes,
    withoutBackdrop,
    openModal,
    closeModal,
  } = useModal();
  const { print, isPrint } = useIsPrint();
  const isMobile = useIsMobile();
  const appMode = useAppMode();
  const isNativeApp = useIsNativeApp();

  return useMemo(() => {
    return {
      modal: {
        component,
        modalRef,
        menuIndex,
        dispatch,
        classes,
        withoutBackdrop,
        openModal,
        closeModal,
      },
      isMobile,
      isNativeApp,
      storeConfig: {},
      print,
      isPrint,
      appMode,
    };
  }, [
    component,
    menuIndex,
    dispatch,
    withoutBackdrop,
    isMobile,
    isNativeApp,
    isPrint,
    appMode,
  ]);
};

export default useProviderValue;
